var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApikeyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n            .cls-8{fill:#f1f1f3;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,15.82a.92.92,0,0,1-1.23-.47,1,1,0,0,1,.13-1.27L8,14l.74-.45a3.42,3.42,0,0,1-.09-.79,3.5,3.5,0,0,1,.09-.8L8,11.54a1,1,0,0,1-.22-1.33,1,1,0,0,1,1.14-.52L9,9.74l.79.46a3.45,3.45,0,0,1,1.3-.72v-1a.94.94,0,0,1,1-.86,1,1,0,0,1,1,.76V9.54a3.22,3.22,0,0,1,1.19.72l.36-.21,3.6-3.7A6.62,6.62,0,0,0,13.12,3l-.19,0A6.27,6.27,0,0,0,6.23,8.5H6.07A6.15,6.15,0,0,0,0,14.73a6.24,6.24,0,0,0,4.28,6l4.84-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,11a1.76,1.76,0,0,0-1.75,1.78A1.78,1.78,0,0,0,10.77,14l2.46-2.52A1.73,1.73,0,0,0,12,11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.75,12.78a1.77,1.77,0,0,0-.52-1.26L10.77,14a1.72,1.72,0,0,0,1.23.51A1.76,1.76,0,0,0,13.75,12.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.19,10.45V9.84a7,7,0,0,0-.94-3.49l-3.6,3.7.54-.31a.91.91,0,0,1,1.22.47,1,1,0,0,1-.12,1.27l-.09.06-.9.53a3.19,3.19,0,0,1,0,1.42l.9.53a1,1,0,0,1,.21,1.33,1,1,0,0,1-1.13.52l-.09,0-.9-.53A3.39,3.39,0,0,1,13.1,16v1a1,1,0,0,1-1,.86,1,1,0,0,1-1-.76V16.07a3.32,3.32,0,0,1-1.3-.72l-.65.39-4.84,5A5.78,5.78,0,0,0,6.1,21H18.87A5.2,5.2,0,0,0,24,15.73V15.4A4.88,4.88,0,0,0,19.19,10.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApikeyActive);
export default __webpack_public_path__ + "static/media/apikey-active.bd9a6c9c32d8d5681868170452d6b676.svg";
export { ForwardRef as ReactComponent };